export const heroData = {
  headline: "Technology Solutions & Talent That Drive Enterprise Results",
  subheadline:
    "For over 20 years, RedeemSoft has empowered banks and businesses with secure compliance recording systems and world-class IT talent. One partner. Two pillars of excellence.",
  ctaPrimary: "Explore Technology Solutions",
  ctaSecondary: "Request Top IT Talent",
};

export const aboutData = {
  headline: "About RedeemSoft",
  description:
    "RedeemSoft is a New Jersey-based technology and talent company with a 20-year track record of delivering results. We partner with banks, financial institutions, and enterprise organizations to solve their most pressing technology and staffing challenges. Our team combines deep domain expertise in compliance recording and voice systems with a rigorous, quality-first approach to IT recruitment.",
  stats: [
    { value: "20+", label: "Years of Experience" },
    { value: "500+", label: "Successful Placements" },
    { value: "50+", label: "Enterprise Clients" },
    { value: "98%", label: "Client Retention Rate" },
  ],
};

export const servicesData = {
  headline: "Our Services",
  subheadline:
    "Whether you need enterprise-grade banking technology, the right people to power your IT initiatives, professional training programs, or dedicated project teams, RedeemSoft delivers with precision and accountability.",
  tabs: [
    {
      id: "technology",
      label: "Technology Solutions",
      title: "Banking & Enterprise Technology",
      description:
        "We design, implement, and support mission-critical systems for financial institutions. From compliance recording to secure enterprise applications, our technology solutions meet the highest standards of reliability and regulatory adherence.",
      offerings: [
        {
          icon: "ri-mic-line",
          title: "Call Recording Solutions",
          description:
            "End-to-end call recording systems for trading floors, contact centers, and back-office operations.",
        },
        {
          icon: "ri-voiceprint-line",
          title: "Voice Recording Systems",
          description:
            "Enterprise voice capture with advanced storage, retrieval, and quality assurance capabilities.",
        },
        {
          icon: "ri-shield-check-line",
          title: "Compliance Recording",
          description:
            "MiFID II, Dodd-Frank, and GDPR-compliant recording solutions that satisfy regulatory audit requirements.",
        },
        {
          icon: "ri-server-line",
          title: "Enterprise Software Implementation",
          description:
            "Full-lifecycle deployment of core banking, CRM, and custom enterprise applications.",
        },
        {
          icon: "ri-refresh-line",
          title: "Digital Transformation",
          description:
            "Legacy modernization, cloud migration, and workflow automation for financial services.",
        },
        {
          icon: "ri-lock-line",
          title: "Secure Applications",
          description:
            "Hardened software architecture with encryption, access control, and security-first design patterns.",
        },
      ],
    },
    {
      id: "recruitment",
      label: "IT Recruitment & Staffing",
      title: "Quality Talent, Delivered Fast",
      description:
        "Our recruitment practice is built on relationships, speed, and an unwavering commitment to quality. We source, vet, and place technology professionals who align with your culture and technical requirements.",
      offerings: [
        {
          icon: "ri-user-search-line",
          title: "IT Staffing",
          description:
            "Flexible staffing models that scale with your project demands and business cycles.",
        },
        {
          icon: "ri-briefcase-line",
          title: "Permanent Recruitment",
          description:
            "Strategic search and placement for full-time technology roles from mid-level to C-suite.",
        },
        {
          icon: "ri-time-line",
          title: "Contract Staffing",
          description:
            "Pre-vetted contractors ready to contribute from day one on short and long-term engagements.",
        },
        {
          icon: "ri-vip-crown-line",
          title: "Executive Hiring",
          description:
            "Discreet, high-touch executive search for CTOs, VPs of Engineering, and technology leaders.",
        },
        {
          icon: "ri-team-line",
          title: "Recruitment Process Outsourcing",
          description:
            "End-to-end RPO partnerships that reduce cost-per-hire while improving candidate quality.",
        },
        {
          icon: "ri-focus-3-line",
          title: "Dedicated Hiring Solutions",
          description:
            "Embedded recruiting teams that operate as an extension of your internal talent function.",
        },
      ],
    },
    {
      id: "training",
      label: "Training & Placement",
      title: "Career Advancement Programs",
      description:
        "We offer a variety of training programs and certification courses that help IT professionals advance their careers in the most demanding and rapidly evolving technology fields.",
      offerings: [
        {
          icon: "ri-graduation-cap-line",
          title: "IT Certification Courses",
          description:
            "Structured training for industry-recognized certifications in cloud, security, data, and development.",
        },
        {
          icon: "ri-user-settings-line",
          title: "Skill Development Programs",
          description:
            "Hands-on workshops and bootcamps designed to close skill gaps and accelerate career growth.",
        },
        {
          icon: "ri-file-list-3-line",
          title: "Resume & Profile Building",
          description:
            "Professional resume optimization, LinkedIn branding, and portfolio development for maximum impact.",
        },
        {
          icon: "ri-chat-3-line",
          title: "Interview Preparation",
          description:
            "Mock interviews, behavioral coaching, and technical screening prep with real industry feedback.",
        },
        {
          icon: "ri-bar-chart-box-line",
          title: "Skill Assessments",
          description:
            "Comprehensive technical evaluations that identify strengths and recommend targeted learning paths.",
        },
        {
          icon: "ri-user-heart-line",
          title: "Placement Support",
          description:
            "Direct connections to hiring managers and ongoing career guidance until successful placement.",
        },
      ],
    },
    {
      id: "projects",
      label: "Projects & Outsourcing",
      title: "End-to-End Project Delivery",
      description:
        "Our dedicated project teams and outsourcing solutions help organizations complete critical technology initiatives on time, within budget, and to specification.",
      offerings: [
        {
          icon: "ri-folder-line",
          title: "Dedicated Project Teams",
          description:
            "Fully staffed project squads with project managers, architects, developers, and QA engineers.",
        },
        {
          icon: "ri-cloud-line",
          title: "Technology Outsourcing",
          description:
            "Strategic outsourcing partnerships that reduce costs while maintaining quality and control.",
        },
        {
          icon: "ri-settings-3-line",
          title: "Managed Services",
          description:
            "Ongoing application management, infrastructure monitoring, and support with defined SLAs.",
        },
        {
          icon: "ri-global-line",
          title: "Offshore Delivery",
          description:
            "Global delivery capabilities with nearshore and offshore teams for 24/7 productivity.",
        },
        {
          icon: "ri-dashboard-line",
          title: "Agile Project Management",
          description:
            "Scrum and Kanban-based delivery with transparent reporting, sprint planning, and retrospectives.",
        },
        {
          icon: "ri-bug-line",
          title: "Quality Assurance",
          description:
            "Comprehensive testing services including automation, performance, security, and UAT validation.",
        },
      ],
    },
  ],
};

export const industriesData = {
  headline: "Industries We Serve",
  subheadline:
    "Our expertise spans regulated industries where precision, security, and compliance are non-negotiable.",
  industries: [
    {
      icon: "ri-bank-line",
      name: "Banking",
      description:
        "Retail, commercial, and investment banks relying on compliant recording and secure systems.",
    },
    {
      icon: "ri-coins-line",
      name: "Financial Services",
      description:
        "Wealth management, brokerage, and fintech firms requiring regulatory-grade technology.",
    },
    {
      icon: "ri-shield-star-line",
      name: "Insurance",
      description:
        "Carriers and agencies needing reliable infrastructure and specialized technology talent.",
    },
    {
      icon: "ri-heart-pulse-line",
      name: "Healthcare",
      description:
        "Health systems and payers with HIPAA-compliant technology and staffing requirements.",
    },
    {
      icon: "ri-computer-line",
      name: "Technology",
      description:
        "SaaS, infrastructure, and product companies scaling engineering and operations teams.",
    },
    {
      icon: "ri-government-line",
      name: "Government",
      description:
        "Federal and state agencies seeking cleared technology professionals and secure solutions.",
    },
  ],
};

export const whyChooseData = {
  headline: "Why Choose RedeemSoft",
  subheadline:
    "Clients stay with us because we deliver on promises, minimize risk, and treat every engagement as a long-term partnership.",
  reasons: [
    {
      icon: "ri-award-line",
      title: "Proven Track Record",
      description:
        "Two decades of successful engagements across banking technology and IT staffing.",
    },
    {
      icon: "ri-speed-line",
      title: "Speed Without Compromise",
      description:
        "Average time-to-fill of 14 days for contract roles. Technology projects delivered on schedule.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Regulatory Expertise",
      description:
        "Deep understanding of MiFID II, Dodd-Frank, GDPR, and industry-specific compliance frameworks.",
    },
    {
      icon: "ri-user-star-line",
      title: "Quality-First Talent",
      description:
        "Rigorous technical screening and behavioral interviews ensure cultural and skill alignment.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Dedicated Support",
      description:
        "A single point of contact and ongoing relationship management from engagement through delivery.",
    },
    {
      icon: "ri-loop-left-line",
      title: "Long-Term Partnership",
      description:
        "We invest in understanding your business so we can anticipate needs and deliver proactive value.",
    },
  ],
};

export const processData = {
  headline: "Our Process",
  subheadline:
    "A structured, transparent approach that keeps you informed and in control at every stage.",
  steps: [
    {
      number: "01",
      title: "Discover",
      description:
        "We begin with a deep-dive consultation to understand your technical environment, compliance requirements, and talent needs.",
    },
    {
      number: "02",
      title: "Design & Match",
      description:
        "For technology projects, we architect a tailored solution. For staffing, we source and pre-vet candidates against your exact criteria.",
    },
    {
      number: "03",
      title: "Deploy & Place",
      description:
        "We execute implementation with minimal disruption, or place talent that integrates seamlessly into your team.",
    },
    {
      number: "04",
      title: "Support & Optimize",
      description:
        "Post-delivery support, continuous optimization, and periodic business reviews to ensure sustained success.",
    },
  ],
};

export const bankingSolutionsData = {
  headline: "Banking Technology Solutions",
  subheadline:
    "Purpose-built systems that help banks capture, manage, and leverage voice communications with total regulatory confidence.",
  solutions: [
    {
      icon: "ri-mic-2-line",
      title: "Call Recording for Banks",
      description:
        "Comprehensive call recording for trading floors, advisory desks, and customer service channels. Supports turret, VoIP, and mobile recording with unified playback and search.",
    },
    {
      icon: "ri-sound-module-line",
      title: "Voice Recording Infrastructure",
      description:
        "Scalable voice capture architecture with high-availability storage, automated retention policies, and disaster recovery.",
    },
    {
      icon: "ri-file-shield-line",
      title: "Compliance Recording",
      description:
        "Regulatory-grade recording that satisfies MiFID II, SEC, FINRA, and internal audit requirements with immutable audit trails.",
    },
    {
      icon: "ri-dashboard-3-line",
      title: "Recording Oversight & QA",
      description:
        "Supervisor dashboards, random sampling tools, and automated quality assurance workflows to monitor adherence and performance.",
    },
  ],
};

export const technologiesData = {
  headline: "Technologies We Work With",
  subheadline:
    "Our consultants and recruiters maintain fluency across the modern technology landscape.",
  categories: [
    {
      name: "Enterprise Platforms",
      techs: ["Salesforce", "ServiceNow", "SAP", "Oracle", "Microsoft Dynamics"],
    },
    {
      name: "Cloud & Infrastructure",
      techs: ["AWS", "Azure", "GCP", "Kubernetes", "Terraform", "VMware"],
    },
    {
      name: "Development",
      techs: ["Java", "Python", "Node.js", "React", "Angular", ".NET"],
    },
    {
      name: "Data & Analytics",
      techs: ["Snowflake", "Databricks", "Power BI", "Tableau", "SQL Server"],
    },
    {
      name: "Security & Compliance",
      techs: ["Splunk", "CrowdStrike", "Okta", "Netskope", "Varonis"],
    },
    {
      name: "Voice & Recording",
      techs: ["Verint", "NICE", "Red Box", "ASC", "IPC", "Speakerbus"],
    },
  ],
};

export const testimonialsData = {
  headline: "What Our Clients Say",
  subheadline:
    "We measure success by the relationships we build and the results we deliver.",
  testimonials: [
    {
      quote:
        "RedeemSoft delivered our compliance recording system on time and under budget. Their understanding of regulatory requirements saved us months of rework.",
      author: "Michael Torres",
      role: "VP of Technology",
      company: "Regional Banking Group",
    },
    {
      quote:
        "We needed 12 senior Java developers in under three weeks. RedeemSoft delivered 14. Every single one was technically strong and culturally aligned.",
      author: "Sarah Chen",
      role: "Director of Engineering",
      company: "Enterprise SaaS Provider",
    },
    {
      quote:
        "The voice recording migration they managed was flawless. Zero downtime, complete data integrity, and a smooth handoff to our operations team.",
      author: "David Park",
      role: "Head of Infrastructure",
      company: "Investment Bank",
    },
    {
      quote:
        "RedeemSoft's RPO program transformed our hiring velocity. We reduced cost-per-hire by 30% while improving quality scores.",
      author: "Jennifer Walsh",
      role: "Chief People Officer",
      company: "Healthcare Technology Firm",
    },
  ],
};

export const faqData = {
  headline: "Frequently Asked Questions",
  subheadline:
    "Quick answers to common questions. Reach out if you need more detail.",
  faqs: [
    {
      question: "What industries does RedeemSoft specialize in?",
      answer:
        "We specialize in banking, financial services, insurance, healthcare, technology, and government sectors. Our dual focus on enterprise technology and IT staffing allows us to serve clients with complex regulatory and technical requirements.",
    },
    {
      question: "How quickly can you fill an IT staffing request?",
      answer:
        "For contract roles, our average time-to-fill is 14 days. For permanent positions, we typically present a shortlist of pre-vetted candidates within 2 to 3 weeks. Executive searches may take 4 to 8 weeks depending on specialization.",
    },
    {
      question: "Are your compliance recording solutions regulator-approved?",
      answer:
        "Yes. Our compliance recording solutions are designed to satisfy MiFID II, SEC, FINRA, Dodd-Frank, and GDPR requirements. We provide immutable audit trails, tamper-evident storage, and configurable retention policies.",
    },
    {
      question: "Do you offer ongoing support after implementation?",
      answer:
        "Absolutely. We offer maintenance, monitoring, optimization, and periodic business review services. Many of our technology clients have been with us for over a decade.",
    },
    {
      question: "Can you handle large-scale digital transformation projects?",
      answer:
        "Yes. We have led cloud migrations, legacy modernization, and workflow automation initiatives for banks and enterprises with hundreds of users. Our project teams include architects, engineers, and project managers.",
    },
    {
      question: "What geographic regions do you serve?",
      answer:
        "Headquartered in New Jersey, we serve clients across the United States and have delivery capabilities in North America, Europe, and Asia through our partner network.",
    },
  ],
};

export const contactData = {
  headline: "Get In Touch",
  subheadline:
    "Ready to explore technology solutions or find the right talent? Schedule a consultation with our team.",
  info: {
    phone: "+1 (732) 548-8002",
    email: "info@redeemsoft.com",
    address: "100 Wood Avenue South, Suite 107, Iselin, NJ 08830",
    hours: "Monday – Friday: 9:00 AM – 6:00 PM EST",
  },
};

export const footerData = {
  company: "RedeemSoft, LLC",
  tagline:
    "Enterprise technology solutions and IT recruitment services trusted by banks and businesses since 2004.",
  links: [
    {
      title: "Services",
      items: [
        { label: "Technology Solutions", href: "#services" },
        { label: "IT Recruitment", href: "#services" },
        { label: "Training & Placement", href: "#services" },
        { label: "Projects & Outsourcing", href: "#services" },
      ],
    },
    {
      title: "Company",
      items: [
        { label: "About Us", href: "#about" },
        { label: "Careers", href: "#careers" },
        { label: "Our Process", href: "#process" },
        { label: "Contact", href: "#contact" },
      ],
    },
    {
      title: "Resources",
      items: [
        { label: "FAQ", href: "#faq" },
        { label: "Testimonials", href: "#testimonials" },
        { label: "Technologies", href: "#technologies" },
        { label: "Banking Solutions", href: "#banking" },
      ],
    },
  ],
  bottom: "© 2026 RedeemSoft, LLC. All rights reserved.",
};

export const clientLogosData = {
  headline: "Trusted by Leading Enterprises",
  subheadline:
    "We partner with banks, financial institutions, and technology organizations across North America.",
  clients: [
    "Deloitte",
    "Cognizant",
    "IBM",
    "AT&T",
    "Verizon",
    "Pfizer",
    "JPMorgan Chase",
    "Goldman Sachs",
    "Morgan Stanley",
    "Bank of America",
    "UBS",
    "BNP Paribas",
    "Accenture",
    "Capgemini",
    "State Street",
    "CGI Federal",
  ],
};

export const careersData = {
  headline: "Current Openings",
  subheadline:
    "Explore opportunities with our client partners. Our recruiters are ready to help you find the perfect match.",
  cta: "View All Openings",
  ctaSecondary: "Submit Your Resume",
  jobs: [
    {
      title: "AX Architect",
      location: "New Jersey",
      type: "Contract",
      category: "Architecture",
      posted: "2 days ago",
    },
    {
      title: "JAVA Developer",
      location: "New Jersey",
      type: "Contract",
      category: "Development",
      posted: "3 days ago",
    },
    {
      title: "Quality Analyst",
      location: "New Jersey",
      type: "Full-Time",
      category: "QA",
      posted: "1 week ago",
    },
    {
      title: "Software Engineer",
      location: "New Jersey",
      type: "Full-Time",
      category: "Engineering",
      posted: "4 days ago",
    },
    {
      title: "Guidewire Consultant",
      location: "New Jersey",
      type: "Contract",
      category: "Consulting",
      posted: "5 days ago",
    },
    {
      title: "UI/UX Designer",
      location: "New Jersey",
      type: "Contract",
      category: "Design",
      posted: "2 days ago",
    },
    {
      title: "DevOps Engineer",
      location: "Remote / NJ",
      type: "Full-Time",
      category: "Infrastructure",
      posted: "1 week ago",
    },
    {
      title: "Data Engineer",
      location: "New Jersey",
      type: "Full-Time",
      category: "Data",
      posted: "3 days ago",
    },
  ],
};

export const employeeTestimonialsData = {
  headline: "Voices from Our Team",
  subheadline:
    "Hear from IT professionals who built their careers through RedeemSoft.",
  testimonials: [
    {
      quote:
        "RedeemSoft handled my immigration paperwork with incredible care and speed. The payroll has always been on time, and the team genuinely supports your growth. It was an overall excellent experience.",
      author: "Ravi Y.",
      role: "Senior Java Developer",
      placedAt: "Fortune 500 Financial Firm",
      years: "4 years with RedeemSoft",
    },
    {
      quote:
        "I was impressed with the policies that give employees space to grow. The immigration and payroll teams are top notch. Even when a vendor delayed payment, RedeemSoft paid my salary on time without question.",
      author: "Neeraj M.",
      role: "Cloud Architect",
      placedAt: "Enterprise SaaS Provider",
      years: "3 years with RedeemSoft",
    },
    {
      quote:
        "Working with RedeemSoft for five years was one of the best professional experiences I have had. Great benefits, stock options, bonuses, and the way they handled my immigration issues was seamless.",
      author: "Ritesh T.",
      role: "Full Stack Engineer",
      placedAt: "Regional Banking Group",
      years: "5 years with RedeemSoft",
    },
    {
      quote:
        "From day one, RedeemSoft treated me like family. The recruitment team matched me to a role that fit both my skills and career goals. I have been with my client for over three years now.",
      author: "Priya S.",
      role: "QA Lead",
      placedAt: "Healthcare Technology Firm",
      years: "3+ years with RedeemSoft",
    },
  ],
};

export const newsletterData = {
  headline: "Stay Informed",
  subheadline:
    "Get industry insights, career tips, and company updates delivered to your inbox.",
  placeholder: "Enter your email address",
  cta: "Subscribe",
  privacy: "We respect your privacy. Unsubscribe anytime.",
};

export const statsCounterData = {
  headline: "RedeemSoft in Numbers",
  subheadline:
    "Two decades of delivering technology solutions and placing exceptional talent.",
  stats: [
    { value: 20, suffix: "+", label: "Years of Excellence" },
    { value: 500, suffix: "+", label: "Successful Placements" },
    { value: 50, suffix: "+", label: "Enterprise Clients" },
    { value: 98, suffix: "%", label: "Client Retention Rate" },
  ],
};